import { useContext } from 'react';
import { Switch } from '@ascd/witsby-components';
import { Box } from '@mui/material';
import { DashboardContext, eDashboardActionType } from '@contexts/dashboardContext';
import { DASHBOARD_COLLECTION_TYPES } from '@utils';

const AdminDashboardSidebarCollectionTypes = () => {
  const {
    dispatch,
    state: { detailsPage },
  } = useContext(DashboardContext);

  if (detailsPage === null || detailsPage?.type !== 'COLLECTION_TYPE') return <Box />;

  return (
    <Box
      className="collection-type"
      sx={(theme) => ({
        p: 2,
        border: '1px solid',
        borderColor: theme.palette.grey[500],
        borderRadius: theme.border.radius.REGULAR,
      })}>
      <Box
        sx={(theme) => ({
          mb: 1,
          color: theme.palette.grey[200],
          fontSize: theme.font.size.REGULAR,
          fontWeight: theme.font.weight.BOLD,
        })}>
        Collection Type:
      </Box>
      {DASHBOARD_COLLECTION_TYPES.map((type) => {
        const {
          detailsPageData: { selectedCollections },
        } = detailsPage;
        const defaultChecked = selectedCollections?.includes(type._id);
        return (
          <Box
            key={type._id}
            sx={{
              mb: 1,
              display: 'flex',
              alignItems: 'center',
            }}>
            <Switch
              defaultChecked={defaultChecked}
              onChange={(_, value) => {
                dispatch({
                  type: 'DETAILS_PAGE' as eDashboardActionType.DETAILS_PAGE,
                  data: {
                    type: 'COLLECTION_TYPE',
                    detailsPageData: {
                      selectedCollections: value
                        ? [...selectedCollections, type._id]
                        : selectedCollections.filter(
                            (selectedCollection: string) => selectedCollection !== type._id,
                          ),
                    },
                  },
                });
              }}
            />
            <Box
              sx={(theme) => ({
                ml: 0.5,
                fontSize: theme.font.size.SMALL,
              })}>
              {type.name}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default AdminDashboardSidebarCollectionTypes;
